/**
 * @module modules/pivot-query-sk
 * @description <h2><code>pivot-query-sk</code></h2>
 *
 * @evt pivot-changed - Emitted every time the control is changed by the user.
 * See PivotQueryChangedEventDetail.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PivotQueryChangedEventName: function() {
        return PivotQueryChangedEventName;
    },
    PivotQuerySk: function() {
        return PivotQuerySk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _json = require("../json");
require("../../../elements-sk/modules/multi-select-sk");
require("../../../elements-sk/modules/select-sk");
const _pivotutil = require("../pivotutil");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
var _PivotQuerySk;
const sortedOps = Object.keys(_pivotutil.operationDescriptions).sort();
const PivotQueryChangedEventName = 'pivot-changed';
let PivotQuerySk = (_PivotQuerySk = class PivotQuerySk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        return (0, _lit.html)`
      <p id="group_by_label-${this.uniqueId}">Which keys should traces be grouped by:</p>
      <multi-select-sk
        id="group_by-${this.uniqueId}"
        aria-labelledby="group_by_label-${this.uniqueId}"
        @selection-changed=${this.groupByChanged}>
        ${this.groupByOptions()}
      </multi-select-sk>

      <label for="operation-${this.uniqueId}">
        <p>What operation should be applied:</p>
        <select id="operation-${this.uniqueId}" @change=${this.operationChanged}>
          ${this.operationOptions()}
        </select>
      </label>

      <p id="summary_label-${this.uniqueId}">
        Optional: Choose summary statistics to calculate for each group:
      </p>
      <multi-select-sk
        id="summary-${this.uniqueId}"
        aria-labelledby="summary_label-${this.uniqueId}"
        @selection-changed=${this.summaryChanged}>
        ${this.summaryOptions()}
      </multi-select-sk>
    `;
    }
    createDefaultPivotRequestIfNull() {
        if (this._pivotRequest === null) {
            this._pivotRequest = {
                group_by: [],
                operation: 'avg',
                summary: []
            };
        }
    }
    allGroupByOptions() {
        var _this__pivotRequest;
        const psKeys = Object.keys(this.paramset);
        const selectedKeys = ((_this__pivotRequest = this._pivotRequest) === null || _this__pivotRequest === void 0 ? void 0 : _this__pivotRequest.group_by) || [];
        // An empty ParamSet could wipe out the users selection, which would be
        // unfortunate, so we always display the values in the current pivotRequest
        // so they don't get lost.
        //
        // Do this by concatenating psKeys and selectedKeys and then removing
        // duplicates.
        let last = '';
        return psKeys.concat(selectedKeys).sort().filter((key)=>{
            if (key === last) {
                return false;
            }
            last = key;
            return true;
        });
    }
    groupByOptions() {
        var _this__pivotRequest;
        const selectedKeys = ((_this__pivotRequest = this._pivotRequest) === null || _this__pivotRequest === void 0 ? void 0 : _this__pivotRequest.group_by) || [];
        const allOptions = this.allGroupByOptions();
        return allOptions.map((key)=>(0, _lit.html)`<div ?selected=${selectedKeys.includes(key)}>${key}</div>`);
    }
    operationOptions() {
        return sortedOps.map((key)=>{
            var _this__pivotRequest;
            return (0, _lit.html)`<option value="${key}" .selected=${((_this__pivotRequest = this._pivotRequest) === null || _this__pivotRequest === void 0 ? void 0 : _this__pivotRequest.operation) === key}>
          ${_pivotutil.operationDescriptions[key]}
        </option>`;
        });
    }
    summaryOptions() {
        var _this__pivotRequest;
        const selections = ((_this__pivotRequest = this._pivotRequest) === null || _this__pivotRequest === void 0 ? void 0 : _this__pivotRequest.summary) || [];
        return sortedOps.map((key)=>(0, _lit.html)`<div ?selected=${selections.includes(key)}>${_pivotutil.operationDescriptions[key]}</div>`);
    }
    groupByChanged(e) {
        this.createDefaultPivotRequestIfNull();
        const allOptions = this.allGroupByOptions();
        this._pivotRequest = _object_spread_props(_object_spread({}, this._pivotRequest), {
            group_by: e.detail.selection.map((index)=>allOptions[index])
        });
        this.emitChangeEvent();
    }
    operationChanged(e) {
        this.createDefaultPivotRequestIfNull();
        this._pivotRequest = _object_spread_props(_object_spread({}, this._pivotRequest), {
            operation: sortedOps[e.target.selectedIndex]
        });
        this.emitChangeEvent();
    }
    summaryChanged(e) {
        this.createDefaultPivotRequestIfNull();
        this._pivotRequest = _object_spread_props(_object_spread({}, this._pivotRequest), {
            summary: e.detail.selection.map((index)=>sortedOps[index])
        });
        this.emitChangeEvent();
    }
    emitChangeEvent() {
        this.dispatchEvent(new CustomEvent(PivotQueryChangedEventName, {
            detail: this.pivotRequest,
            bubbles: true
        }));
    }
    /** Returns null if the pivot.Request isn't valid. */ get pivotRequest() {
        if ((0, _pivotutil.validatePivotRequest)(this._pivotRequest)) {
            return null;
        }
        return this._pivotRequest;
    }
    set pivotRequest(v) {
        this._pivotRequest = v;
    }
    constructor(...args){
        super(...args);
        this.uniqueId = `${PivotQuerySk.nextUniqueId++}`;
        this.paramset = (0, _json.ParamSet)({});
        this._pivotRequest = null;
    }
}, (()=>{
    _PivotQuerySk.nextUniqueId = 0;
})(), _PivotQuerySk);
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", typeof _json.ParamSet === "undefined" ? Object : _json.ParamSet)
], PivotQuerySk.prototype, "paramset", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], PivotQuerySk.prototype, "_pivotRequest", void 0);
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object
    ])
], PivotQuerySk.prototype, "pivotRequest", null);
PivotQuerySk = _ts_decorate([
    (0, _decorators.customElement)('pivot-query-sk')
], PivotQuerySk);
